import React, {Component} from 'react';
import {connect} from 'react-redux';
import Share from "./Share";

class RightMenuDetailsEksport extends Component {
    render() {
        return (
            <div className={'right-menu-details-container'} id={this.props.id} style={this.props.style}>
                <div className='right-menu-details-container-content'>
                    <Share/>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(RightMenuDetailsEksport);


// WEBPACK FOOTER //
// ./src/RightMenu/RightMenuDetailsEksport.js